import React from "react";
import { motion } from "framer-motion";
import {
  useInView,
  combine,
  HOVER_SHADOW,
} from "../../animationUtils";
import * as animationUtils from "../../animationUtils";

export default function MotionTile({
  children,
  className = "",
  delay = 0,
  entryAnimation = "FADE_UP",
}) {
  const [tileRef, inView] = useInView();

  const motionVariants = combine(animationUtils[entryAnimation], HOVER_SHADOW, {
    variants: {
      start: {
        transition: { delay },
      },
    },
  });

  return (
    <motion.div
      ref={tileRef}
      className={`projects-grid__tile ${className}`}
      initial="hidden"
      whileHover="hoverShadow"
      {...(inView ? { animate: "start" } : {})}
      {...motionVariants}
    >
      {children}
    </motion.div>
  );
}
